import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CurrentFacilityService } from '../../services';

@Component({
    standalone: true,
    selector: 'app-image-by-facility',
    templateUrl: './image-by-facility.component.html',
    styleUrls: ['./image-by-facility.component.scss'],
    imports: [CommonModule, NgOptimizedImage],
})
export class ImageByFacilityComponent implements OnInit {
    private facilityName = '';
    public imageName = '';

    @Input() src: string;
    @Input() title = '';
    @Input() alt = '';
    @Input() width = '';
    @Input() height = '';
    @Input() type = 'svg';
    @Input() priority = false;
    @Input() isFullPath = false;

    constructor(private currentFacilityService: CurrentFacilityService) {}

    ngOnInit(): void {
        if (this.isFullPath) {
            this.imageName = this.src;
            return;
        }
        this.facilityName = this.currentFacilityService.getFacilitySource();

        this.buildImageName();
    }

    buildImageName(): void {
        this.imageName = `assets/${this.facilityName}/img/${this.src}.${this.type}`;
    }
}
